// src/pages/AdminTechnologySelector.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { categorizedTechnologies } from '../AdminComponents/techData';

const AdminTechnologySelector = () => {
 const navigate = useNavigate();

 return (
 <div className="min-h-screen bg-bgMain text-body p-8 relative overflow-hidden font-sans">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 <h1 className="text-4xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-12 uppercase tracking-tighter relative z-10">Manage Questions</h1>

 {Object.entries(categorizedTechnologies).map(([category, techList]) => (
 <div key={category} className="mb-16 relative z-10">
 <h2 className="text-2xl font-bold text-primary mb-8 border-l-4 border-primary pl-4 uppercase tracking-widest text-sm">{category}</h2>
 <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
 {techList.map((tech, index) => (
 <div
 key={index}
 onClick={() => navigate(`/admin/manage-questions/${tech.title}`)}
 className="cursor-pointer bg-bgSection rounded-3xl border-2 border-primary/30 p-6 flex flex-col items-center justify-center transition-all duration-300 hover:scale-[1.05] hover:border-primary hover:shadow-[0_0_25px_rgba(79, 70, 229,0.2)] group"
 >
 <div className="w-16 h-16 mb-4 p-2 rounded-2xl bg-bgMain border border-accentGray/30 flex items-center justify-center group-hover:border-primary/50 transition-all">
 <img src={tech.image} alt={tech.title} className="w-full h-full object-contain" />
 </div>
 <h3 className="text-sm font-bold text-body group-hover:text-white transition-colors text-center">{tech.title}</h3>
 </div>
 ))}
 </div>
 </div>
 ))}
 </div>
 );
};

export default AdminTechnologySelector;




